import React, { useState, useRef, useEffect } from "react";

export function DropdownMenu({ children, ...props }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={ref} className="relative" {...props}>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            open,
            setOpen,
          });
        }
        return child;
      })}
    </div>
  );
}

export function DropdownMenuTrigger({ children, open, setOpen, ...props }) {
  return (
    <button
      type="button"
      onClick={() => setOpen(!open)}
      aria-expanded={open}
      aria-haspopup="true"
      {...props}
    >
      {children}
    </button>
  );
}

export function DropdownMenuContent({ children, open, className, ...props }) {
  if (!open) return null;

  return (
    <div
      className={`absolute z-50 min-w-[8rem] overflow-hidden rounded-md border bg-white shadow-md animate-in fade-in-80 mt-1 ${className || ""}`}
      {...props}
    >
      <div className="p-1">{children}</div>
    </div>
  );
}

export function DropdownMenuItem({ children, className, ...props }) {
  return (
    <button
      className={`relative flex w-full cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none hover:bg-gray-100 ${className || ""}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function DropdownMenuLabel({ children, className, ...props }) {
  return (
    <div
      className={`px-2 py-1.5 text-sm font-semibold ${className || ""}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function DropdownMenuSeparator({ className, ...props }) {
  return (
    <div
      className={`-mx-1 my-1 h-px bg-gray-200 ${className || ""}`}
      {...props}
    />
  );
}
